import { isOrWasTeam, useGetLoggedInUser } from '@upright/ui/common/generic/hooks';
import { Route, Routes } from 'react-router-dom';
import { CookieConsent, CookieYesUrl } from '@upright/ui/common/generic/components/legal/cookie-consent';
import { isAwsDev } from '@upright/common/environment';

export function CookieConsentMaybe() {
  return (
    <Routes>
      <Route path="/share/:entityId" element={null} />
      <Route path="/render/*" element={null} />
      <Route path="/*" element={<CookieConsentPlatform />} />
    </Routes>
  );
}

const CookieConsentPlatform = () => {
  /**
   * The CookieYes third-party script must never load for team users. It has been observed to
   * re-inject itself across re-renders and take the browser into a fatal recursion loop (ET note
   * 2023-09-15). It also drops a persistent "cookie preferences" badge into the DOM outside React's
   * control; in dev environments CookieYes places that badge bottom-left, where it overlaps the
   * internal-tools launcher and cannot be dismissed (PLT-5601).
   *
   * We gate on `isOrWasTeam` rather than the logged-in user's team flag alone because
   * `loggedInUser` is still empty on the first render(s): a plain team check reads as false during
   * that window, the script loads, and the badge is already in the DOM (and cannot be removed by a
   * later React unmount) by the time the user resolves. `isOrWasTeam` reads the synchronous
   * localStorage trace left by any prior team login on this browser, so the script is suppressed
   * from the very first render for anyone who is — or was — a team user.
   */
  const user = useGetLoggedInUser();
  if (isOrWasTeam(user)) return <></>;

  const url = isAwsDev() ? CookieYesUrl.DEVELOPMENT : CookieYesUrl.PLATFORM;

  return <CookieConsent url={url} />;
};
